import * as m from "../../es2015/plugins/annotation";
window.am4plugins_annotation = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/annotation.js
// module id = null
// module chunks = 